import React from "react";
import { Col, Row } from "react-bootstrap";

import {
  DiMysql,
  DiMongodb
} from "react-icons/di";

function Databases() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons" title="MySql">
        <DiMysql />
      </Col>
      <Col xs={4} md={2} className="tech-icons" title="Mongo Db">
        <DiMongodb />
      </Col>
      
    </Row>
  );
}

export default Databases;
